import * as React from 'react';
import { AccountButton } from 'components';
import {
    Container,
    AbsoluteBackButton,
    HeaderLogo,
    StyledAccountButtonContainer,
} from './WithHeader.style';
import { useWithHeaderVM } from './useWithHeaderVM';

type WithHeaderProps = {
    isSticky?: boolean;
    headerContent?: React.ReactNode;
    disabledClickBack?: boolean;
    disabledClickLogo?: boolean;
    onClickBack?: () => void;
    onClickLogo?: () => void;
    hasAccountButton?: boolean;
};

export const WithHeader: React.FunctionComponent<React.PropsWithChildren<WithHeaderProps>> = ({
    isSticky,
    headerContent,
    disabledClickBack,
    disabledClickLogo,
    onClickBack,
    onClickLogo,
    children,
    hasAccountButton,
}) => {
    const { isFoodCourt, restaurantLogo, logoAriaLabel, goPrevious, redirectToHome } =
        useWithHeaderVM();

    const handleClickBack = () => {
        if (disabledClickBack) return;

        if (onClickBack) {
            onClickBack();
            return;
        }

        goPrevious();
    };

    const handleClickLogo = () => {
        if (disabledClickLogo) return;

        if (onClickLogo) {
            onClickLogo();
            return;
        }

        redirectToHome();
    };

    return (
        <>
            <Container
                isSticky={!!isSticky}
                customContent={!!headerContent}
                data-testid="with-header"
            >
                {!disabledClickBack && (
                    <AbsoluteBackButton onClick={handleClickBack} data-testid="back-button" />
                )}

                {!headerContent && (
                    <HeaderLogo
                        role="img"
                        aria-label={logoAriaLabel}
                        onClick={handleClickLogo}
                        style={
                            isFoodCourt
                                ? {}
                                : {
                                      backgroundImage: `url(${restaurantLogo})`,
                                  }
                        }
                        data-testid={isFoodCourt ? 'brand-logo' : 'restaurant-logo'}
                    />
                )}

                {headerContent && <>{headerContent}</>}

                {hasAccountButton && (
                    <StyledAccountButtonContainer>
                        <AccountButton />
                    </StyledAccountButtonContainer>
                )}
            </Container>
            {children}
        </>
    );
};
